// extracted by mini-css-extract-plugin
export default {"waikawaGray":"#666","black":"#000","footer":"footer_footer__RnRU7","link":"footer_link__sK9m0","linkContainer":"footer_linkContainer__LdnVU","linkText":"footer_linkText__PF1xV"};